import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.197 9.788c0 .45-.375.803-.8.803h-.8l.017 4.005q0 .101-.012.202v.403a1 1 0 0 1-1 1h-.4q-.041 0-.083-.003-.052.004-.105.003h-1.412a1 1 0 0 1-1-1V13a.8.8 0 0 0-.8-.8h-1.6a.8.8 0 0 0-.8.8v2.2a1 1 0 0 1-1 1H6.003q-.057-.001-.113-.005-.045.004-.09.005h-.4a1 1 0 0 1-1-1v-2.8q0-.036.002-.07v-1.74h-.802a.79.79 0 0 1-.8-.803c0-.225.075-.425.25-.6L9.46 3.6c.175-.175.375-.2.55-.2a.83.83 0 0 1 .525.175l6.386 5.613c.2.175.3.375.275.6"
    }, null, -1)
  ]))]))
}
export default { render: render }